export const PLAN_TYPES = {
  GIFTS_GIFTS_AND_GIFTS: 1,
  MAINLY_CASH_FUNDS: 2,
};
